import React, { useEffect, useState } from "react";
import style from "./message.module.css";
interface prop {
  text: string;
  seconds: number[];
  reload?: boolean;
  bgColor?: string;
  color?: string;
}
const Message: React.FC<prop> = ({ text, seconds, reload, bgColor, color }) => {
  const [message, setMessage] = useState({
    openAni: false,
    closeAni: false,
    display: false,
  });
  useEffect(() => {
    setTimeout(function () {
      setMessage({ ...message, display: true, openAni: true });
    }, seconds[0]);
    setTimeout(function () {
      setMessage({ display: true, openAni: false, closeAni: true });
    }, seconds[1]);
    setTimeout(function () {
      setMessage({ display: false, openAni: false, closeAni: false });
    }, seconds[2]);
  }, []);
  return (
    <div
      style={{
        background: bgColor,
      }}
      className={`${style.message} ${message.display ? "" : "d-none"}${
        message.openAni ? style.show : ""
      }${message.closeAni ? style.close : ""}`}
    >
      <span id="message" style={{ color: color }}>
        {text}
      </span>
      {reload && (
        <img
          id="reload"
          src={`${process.env.PUBLIC_URL}/assets/icon/refresh.svg`}
          alt=""
          onClick={() => window.location.reload()}
        />
      )}
    </div>
  );
};

export default Message;
